import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/providers/AuthProvider'
import { useLocationRef } from '@/contexts/RefContext'
import { PATHS } from '@/router/paths'

export function RequireAuth() {
	const { isAuthenticated } = useAuth()
	const location = useLocation()
	const locationRef = useLocationRef()

	if (!isAuthenticated) {
		return <Navigate to={PATHS.accountEntry(locationRef)} state={{ from: location }} replace />
	}

	return <Outlet />
}
